export const formatPhone = (phone) => {
    if (!phone) {
        return null;
    }

    let numbers = phone.replace(/\D/g, '');

    if (numbers.startsWith('1')) {
        numbers = numbers.substring(1);
    }

    const char = { 0: '(', 3: ') ', 6: '-' };

    phone = '';

    for (let i = 0; i < numbers.length; i++) {
        phone += (char[i] || '') + numbers[i];
    }

    return phone;
};
